import { useMemo } from 'react';

import ApiCalls from '../../components/api/apiCalls';
import IOperationTypesService from '../../components/services/interfaces/OperationTypesService';
import OperationTypesService from '../../components/services/OperationTypesService';

const useOperationTypesService = () => {
  return useMemo(
    (): IOperationTypesService => new OperationTypesService(new ApiCalls()),
    []
  );
};

export default useOperationTypesService;
